(() => {
    class Form extends App.Component {
        constructor(container) {
            super(container);

            this.validator  = this.read('validator', false) || null;
            this.containers = {
                notifications: this.container.querySelector('.form-notifications'),
            };
            this.success = [];

            /* Storage values to use later, recommended for dynamic state */
            this.storage = this.read('storage', false);
            if (this.storage) {
                this.values = App.Components.Form.storage[this.name] || {};
            }
            // Interact with notifications
            App.Interface.Notification;
            App.wait('App.Interface.Notification', () => App.Interface.Notification.addPosition(this.name, this));
            // Wait only for cases of (global) async loading
            App.wait('App.Entities.Notifications', () => this.Notifications = new App.Entities.Notifications());
            this.bind();
        }

        /* GETTERS */
        /**
         * Define field groups
         */
        get groups() {
            if (this._groups === undefined) {
                let groups = {};
                this.container.querySelectorAll('.form-group').forEach(group => {
                    groups[group.Instance.name] = group.getComponent();
                });
                this._groups = groups;
            }
            return this._groups;
        }

        /**
         * The name parameter is optional and specifies the input by name or ID below which the
         * message will be displayed. A false-y name will produce a message at the start of the form.
         * @param message   - Message content
         * @param name      - Field name or id below which the message will appear.
         * @param type      - message type determining its appearance.
         * @returns this
         */
        addNotification(message, name = 'form', type = 'alert') {
            this.Notifications.add(name, message, type);
            return this;
        }

        addNotifications(bundle) {
            for (let key in bundle) {
                let notification = bundle[key][0] || bundle[key]; // @todo display all notifications
                if (typeof notification === 'object') {
                    this.addNotification(notification.message, this.hasField(key) ? key : 'form', notification.type);
                }
            }
            return this;
        }

        /*
        * Set notification on form-group right away
        */
        setNotification(notification, name) {
            if (name in this.groups) this.groups[name].setNotification(notification.message, notification.type);
        }

        /**
         *
         * @param message - contents of the error message
         * @param name - Field name or id below which the error will be displayed
         * @returns {Form}
         */
        addError(message, name = false) {
            return this.addNotification(message, name, 'error');
        }

        /**
         * @param name of field
         * @returns value
         */
        getValue(name) {
            if(this.groups[name] !== undefined) return this.groups[name].value;
        }

        /**
         * @param name of field
         * @param value
         * @returns value
         */
        setValue(name, value) {
            if (this.groups[name] !== undefined) {
                this.storageValue(name, value);
                return this.groups[name].value = value;
            }
        }

        /**
         * Set an storage value by name
         * @param name of field
         * @param value
         * @returns this
         */
        storageValue(name, value) {
            if (this.storage) {
                if (App.Components.Form.storage[this.name] === undefined)
                    App.Components.Form.storage[this.name] = {};
                App.Components.Form.storage[this.name][name] = value;
            }
            return this;
        }

        handleNotifications(bundle) {
            this
                .addNotifications(bundle)
                .update()
            ;
            return this;
        }

        displayNotifications(content = '') {
            let n = this.Notifications.get();
            for (let name in n) {
                let notifications = n[name];
                if (name === 'form') {
                    notifications.forEach(notification => {
                        content+= App.Template.parse('form-notifications-item', notification);
                    });
                } else {
                    notifications.forEach(notification => {
                        this.setNotification(notification, name);
                    });
                }
                this.containers.notifications.innerHTML = content;
            }
            this.Notifications.reset();

            return this;
        }

        hasField(name) {
            return this.groups[name] !== undefined;
        }

        get action() {
            return this.container.action;
        }

        get name() {
            return this.container.getAttribute('name');
        }

        get values() {
            const values = {}
            for (const group in this.groups) {
                if (this.groups[group].value) {
                    values[group] = this.groups[group].value;
                }
            }
            return values;
        }

        set values(values) {
            for (let key in values) {
                if (values[key]) {
                    this.setValue(key, values[key]);
                }
            }
        }

        bind() {
            let Self = this;
            $(this.container).on('blur change', 'input, select, textarea', function() {
                if (Self.storage) App.Components.Form.storage[Self.name] = Self.values;
            });

            this.container.addEventListener('submit', event => {
                App.Components.Form.submitted = this;
                /* VALIDATOR */
                if (this.validator) {
                    App.Interface.Api.post(
                        this.validator,
                        {},
                        this.values,
                        {async: false},
                        response => {},
                        response => {
                            event.preventDefault();
                            event.stopPropagation();
                            for (let name in response.notifications) {
                                let notification = response.notifications[name][0];
                                if (typeof notification !== 'undefined') {
                                    this.addNotification(notification.message, name, notification.type);
                                }
                            }
                            this.update();
                            return false;
                        }
                    );
                }

                if (this.container.target === 'ajax') {
                    event.preventDefault();
                    event.stopPropagation();
                    let request = new App.Entities.Request(this);
                    request.url         = this.action;
                    request.data        = this.values;
                    request.method      = 'post';
                    request.call();
                }
                if (this.container.target === 'api') {
                    event.preventDefault();
                    event.stopPropagation();
                    const action = this.action.replace(this.container.baseURI, '');
                    App.Interface.Api.promise(action, App.Utilities.Serialize.formToObject(this.container), {
                        method: App.Interface.Api.METHOD_POST,
                    }).then(response => {
                        this.response = response;
                        this.Observer.notify();
                    });

                }
            });
        }

        get statusCode() {
            return {
                200: response => {
                    this.success.forEach(success => {
                        success(response);
                    });
                },
                400: response => {
                    this.addNotifications(response.responseJSON.notifications);
                    this.update();
                },
            };
        }

        done(request) {
            // In case of a redirection and if url has change
            if (request.response.url !== undefined && request.response.url !== request.url) {
                App.Layout.load(request.response);
            }
            return this;
        }

        onSuccess(action) {
            this.success.push(action);
            return this;
        }

        fail(request) {
            App.Observer.notify();
        }

        /**
         * Empty entire form
         */
        empty() {
            for (const name in this.groups) {
                const group = this.groups[name];
                // We only empty possible fields
                switch (group.input.type) {
                    case 'radio':
                    case 'checkbox':
                    case 'select-one':
                        continue;
                    default:
                        this.groups[name].value = '';
                }
            }
        }

        /* Outputs and empties form and field message storage. */
        update() {
            this
                .displayNotifications()
            ;
        }
    }
    // Attach an instance of this object to every element matching the selector.
    App.Components.register('form.advanced', Form);
})();

// Global values for forms
(() => {
    class Form {
        constructor() {
            // Manage forms storage
            this.storage = {};
            // collect forms to track
            this.tracking = [];
        }
        // Track a new form
        track(name) {
            this.tracking.push(name);
        }
        // Check if form is tracking a form
        tracks(name) {
            return this.tracking.includes(name);
        }
    }
    App.Components.Form = new Form;
})();
